import { cn } from '@/lib/utils'

/**
 * Skeleton placeholder.
 *
 * Uses `bg-muted` (neutral dark gray) rather than `bg-accent` (brand
 * purple) so it reads as "content is loading" rather than "this area is
 * urgent." The brand-color default we inherited was producing a visible
 * red flash on the map area during route-map.tsx's dynamic-import load
 * — reported by Chris 2026-04-18. Neutral is the correct shadcn default.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="skeleton"
			className={cn('bg-muted animate-pulse rounded-md', className)}
			{...props}
		/>
	)
}

export { Skeleton }
